import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from 'i18next-http-backend';

import en from "./en.json";
import si from "./si.json";
import ta from "./ta.json";

i18n
.use(HttpBackend)
  .use(LanguageDetector) // Detect browser language automatically
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      si: { translation: si },
      ta: { translation: ta }
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
